import { useState } from "react";
import { FileText, Loader2 } from "lucide-react";

import { downloadReportDocx } from "@/lib/download";

type State = "idle" | "loading" | "error";

const BASE_CLASS =
  "inline-flex items-center gap-1.5 text-sm px-2 py-1 rounded transition-colors disabled:opacity-100";

/**
 * Downloads a report as a Word (.docx) file via the server-side conversion
 * endpoint. Authenticated fetch → blob → <a download>. Shows idle / loading /
 * error states.
 */
export function DOCXButton({ reportId }: { reportId: number }) {
  const [state, setState] = useState<State>("idle");

  const handleClick = async () => {
    if (state === "loading") return;
    setState("loading");
    try {
      await downloadReportDocx(reportId);
      setState("idle");
    } catch (err) {
      console.error("DOCX download failed:", err);
      setState("error");
      setTimeout(() => setState("idle"), 2000);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={state === "loading"}
      className={`${BASE_CLASS} ${
        state === "error"
          ? "text-red-600 hover:text-red-700"
          : "text-muted-foreground hover:text-foreground hover:bg-muted"
      }`}
      title={state === "error" ? "Download failed — try again" : "Download as Word (.docx)"}
    >
      {state === "loading" ? (
        <Loader2 className="w-3.5 h-3.5 animate-spin" />
      ) : (
        <FileText className="w-3.5 h-3.5" />
      )}
      DOCX
    </button>
  );
}
